import * as React from 'react'
import type {SVGProps} from 'react'
const SvgFlag = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
        <path
            fill="#142745"
            d="M15 37h-2.32V11H15zm20.32-14.18V11a6.1 6.1 0 0 1-2.4 2.73 5.24 5.24 0 0 1-3 .7 17 17 0 0 1-3.26-.59q-1.7-.47-3.3-.95a15 15 0 0 0-3-.59 3.4 3.4 0 0 0-2.43.7 4.74 4.74 0 0 0-1.54 2.73v11.82a8.14 8.14 0 0 1 3-2 6.8 6.8 0 0 1 3-.41 19 19 0 0 1 2.88.54q1.46.39 2.81.71a9.3 9.3 0 0 0 2.6.26 4.22 4.22 0 0 0 2.43-1 8.4 8.4 0 0 0 2.21-2.83"
        />
    </svg>
)
export default SvgFlag
